// import Axios from "axios";
import Axios from '../api/index'

export const inviteFriends = (data) => {
    return Axios.post("/user/invited_friends", data);
  };